import React, { Component } from 'react';
import styles from './HQBeta.module.css';

class HQBeta extends Component {
    constructor(props) {
        super(props);
    };

    render() {
        return (
            <a href='/feedback'>
                <div className={styles.container}>
                    beta
                </div>
            </a>
        );
    };
};

export default HQBeta;